import { PROMO_HEADER_MOBILE_EVENTS, PROMO_MOBILE_MENU_EVENTS } from '../config';

export default {
  data() {
    return {
      isMobileMenuOpen: false,
    };
  },
  created() {
    this.$eventBus.$on(PROMO_HEADER_MOBILE_EVENTS.PROMO_HEADER_MOBILE_MENU_TOGGLE, this.toggleMobileMenu);
    this.$eventBus.$on(PROMO_MOBILE_MENU_EVENTS.PROMO_MOBILE_MENU_CLOSE, this.closeMobileMenu);
  },
  beforeDestroy() {
    this.$eventBus.$off(PROMO_HEADER_MOBILE_EVENTS.PROMO_HEADER_MOBILE_MENU_TOGGLE, this.toggleMobileMenu);
    this.$eventBus.$off(PROMO_MOBILE_MENU_EVENTS.PROMO_MOBILE_MENU_CLOSE, this.closeMobileMenu);
  },
  methods: {
    toggleMobileMenu(isMenuOpen) {
      if (this.isMobileMenuOpen !== isMenuOpen) {
        this.isMobileMenuOpen = isMenuOpen;
        isMenuOpen
          ? this.$eventBus.$emit(PROMO_MOBILE_MENU_EVENTS.PROMO_MOBILE_MENU_OPEN)
          : this.$eventBus.$emit(PROMO_MOBILE_MENU_EVENTS.PROMO_MOBILE_MENU_CLOSE);
      }
    },
    closeMobileMenu() {
      this.toggleMobileMenu(false);
    },
    closeMobileMenuOnResize({ isDesktop }) {
      if (isDesktop) {
        this.toggleMobileMenu(false);
      }
    },
  },
};
